import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import useMultiSourceCodeList from "./hooks/useMultiSourceCodeList";

const MultiSourceCodeList = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
}) => {
  const multiSourceCodeListData = useMultiSourceCodeList(
    onSelect,
    hideModal,
    params,
    lookupType
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={multiSourceCodeListData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {multiSourceCodeListData.screen_title} -{" "}
          <span className="heading-cod">
            {multiSourceCodeListData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={multiSourceCodeListData.formFields}
        dropdownValues={multiSourceCodeListData.dropdownValues}
        paramsData={multiSourceCodeListData.paramsData}
        updataParamData={multiSourceCodeListData.updateParamData}
      />
      <ButtonsSection ctaButtons={multiSourceCodeListData.ctaButtons} />
      <DisplayTable
        data={multiSourceCodeListData.data}
        parmKey={multiSourceCodeListData.parmKey}
        menuOptions={multiSourceCodeListData.menuOptions}
        tableHeaders={multiSourceCodeListData.columnDef}
        setRowData={multiSourceCodeListData.setRowData}
        selectedPriceSchedules={multiSourceCodeListData.selectedRows}
        setSelectedPriceSchedules={multiSourceCodeListData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={multiSourceCodeListData.first}
          rows={multiSourceCodeListData.rows}
          totalRecords={multiSourceCodeListData.totalRecords}
          currentPage={multiSourceCodeListData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={multiSourceCodeListData.onPageChange}
        />
      </div>
      {multiSourceCodeListData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={multiSourceCodeListData.isConfirmationModalOpen}
          onRequestClose={multiSourceCodeListData.closeConfirmationModal}
          onBack={multiSourceCodeListData.closeConfirmationModal}
          onSave={multiSourceCodeListData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={multiSourceCodeListData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default MultiSourceCodeList;
